import moment from "moment";
import {
  Get_Automation_Usage,
  Get_Email_Recevied,
  Get_Email_Sent,
  Get_Inbound_Calls,
  Get_SMS_Recevied,
  Get_SMS_Sent,
  Get_Total_Leads,
} from "./graphql-queries";
import { formatDateForGridFilters } from "@/services/generic.methods";
import { time, REPORT_NA_VALUE } from "../global/constants";
import {
  faEnvelope,
  faMessage,
  faUser,
} from "@fortawesome/free-regular-svg-icons";
import { faCalendar, faPhone } from "@fortawesome/free-solid-svg-icons";
import { CallTypes } from "@/services/dropdown-enums";
import KeyboardCommandKeyIcon from "@mui/icons-material/KeyboardCommandKey";
import { Get_Appointment_Scheduled } from "../analytics/graphql-queries";
export const colorEnums = {
  purple: { bg: "#F2E7FF", text: "#5200B2" },
  blue: { bg: "#E5F5FF", text: "#207EAC" },
  orange: { bg: "#FFF0E7", text: "#CE6E33" },
  green: { bg: "#EBFDEF", text: "#33A539 " },
  darkBlue: { bg: "#E7EFFF ", text: "#3E5889" },
  darkGreen: { bg: "#DFF5F1 ", text: "#178A75" },
  darkPurple: { bg: "#E6D7DD", text: "#A4315B" },
};

export const DummyCards = [
  {
    id: 1,
    name: "Total Leads",
    currentValue: 26,
    previousValue: 20,
    color: "purple",
    query: Get_Total_Leads,
    dataKey: "leadsGeneratedReport",
    icon: faUser,
  },
  {
    id: 2,
    name: "Email Sent",
    currentValue: 30,
    previousValue: 40,
    color: "orange",
    query: Get_Email_Sent,
    dataKey: "emailSentReport",
    icon: faEnvelope,
  },
  {
    id: 3,
    name: "Email Received",
    currentValue: 30,
    previousValue: 40,
    color: "orange",
    query: Get_Email_Recevied,
    dataKey: "emailReceivedReport",
    icon: faEnvelope,
  },
  {
    id: 4,
    name: "SMS Sent",
    currentValue: 20,
    previousValue: 30,
    color: "green",
    query: Get_SMS_Sent,
    dataKey: "smsSentReport",
    icon: faMessage,
  },
  {
    id: 5,
    name: "SMS Received",
    currentValue: 20,
    previousValue: 30,
    color: "green",
    query: Get_SMS_Recevied,
    dataKey: "smsReceivedReport",
    icon: faMessage,
  },
  {
    id: 6,
    name: "Appointment Scheduled",
    currentValue: 20,
    previousValue: 25,
    color: "blue",
    query: Get_Appointment_Scheduled,
    dataKey: "appointmentScheduledReport",
    icon: faCalendar,
  },
  {
    id: 7,
    name: "Inbound Calls",
    currentValue: 15,
    previousValue: 7.5,
    color: "blue",
    query: Get_Inbound_Calls,
    staticParams: { interactionType: { eq: CallTypes.Inbound } },
    dataKey: "voiceCallReport",
    icon: faPhone,
  },
  {
    id: 8,
    name: "Automation Usage",
    currentValue: 15,
    previousValue: 7.5,
    color: "darkPurple",
    query: Get_Automation_Usage,
    // staticParams: { interactionType: { eq: CallTypes.Inbound } },
    dataKey: "automationUsageKpi",
    subDataKey: "usagePercentage",
    withoutWhere: true,
    unit: "%",
    icon: KeyboardCommandKeyIcon,
    materialIcon: true,
  },
];

const getRange = (duration = "", subtractCount = 0) => {
  return {
    gte: moment()
      .subtract(subtractCount, duration)
      .startOf(duration)
      .startOf("day"),
    lte: moment()
      .subtract(subtractCount, duration)
      .endOf(duration)
      .endOf("day"),
  };
};

export const GetRangeByDuration = (
  key,
  format = time.format.dateOnly,
  toUtC = false
) => {
  let mainObj = {};
  let first = { gte: "", lte: "" };
  let second = { gte: "", lte: "" };
  switch (key) {
    case "today":
      first.gte = moment().startOf("day");
      first.lte = moment().endOf("day");
      // first.lte = moment().endOf("day").add(1, "day");
      second.gte = moment().subtract(1, "day").startOf("day");
      second.lte = moment().subtract(1, "day").endOf("day");
      break;

    case "last_24_hour":
      first.gte = moment().subtract(24, "hours");
      first.lte = moment();
      second.gte = moment().subtract(48, "hours");
      second.lte = moment().subtract(24, "hours");
      break;

    case "yesterday":
      first.gte = moment().subtract(1, "day").startOf("day");
      first.lte = moment().subtract(1, "day").endOf("day");
      second.gte = moment().subtract(2, "day").startOf("day");
      second.lte = moment().subtract(2, "day").endOf("day");
      break;

    case "this_week":
      first = { ...getRange("week") };
      second = { ...getRange("week", 1) };
      break;

    case "last_week":
      first = { ...getRange("week", 1) };
      second = { ...getRange("week", 2) };
      break;

    case "this_month":
      first = { ...getRange("month") };
      second = { ...getRange("month", 1) };
      break;

    case "last_30_days":
      first.gte = moment().subtract(30, "days");
      first.lte = moment();
      second.gte = moment().subtract(60, "days");
      second.lte = moment().subtract(30, "days");
      break;

    case "last_month":
      first = { ...getRange("month", 1) };
      second = { ...getRange("month", 2) };
      break;

    case "this_year":
      first = { ...getRange("year") };
      second = { ...getRange("year", 1) };
      break;

    case "last_year":
      first = { ...getRange("year", 1) };
      second = { ...getRange("year", 2) };
      break;
  }
  if (toUtC) {
    mainObj = {
      first: {
        gte: first.gte.utc().format(format),
        lte: first.lte.utc().format(format),
      },
      second: {
        gte: second.gte.utc().format(format),
        lte: second.lte.utc().format(format),
      },
    };
    return mainObj;
  } else {
    mainObj = {
      first: { gte: first.gte.format(format), lte: first.lte.format(format) },
      second: {
        gte: second.gte.format(format),
        lte: second.lte.format(format),
      },
    };
    return mainObj;
  }
};

const makeDataByFieldType = (type = "", key, filters) => {
  switch (type) {
    case "slider": {
      let arr = [];

      if (filters[key]?.[0]) {
        arr.push({
          [key]: {
            gte: filters[key]?.[0],
          },
        });
      }

      if (filters[key]?.[1]) {
        arr.push({
          [key]: {
            lte: filters[key]?.[1],
          },
        });
      }

      return arr;
    }
    case "date_range": {
      let arr = [];
      arr = [
        {
          [key]: {
            gte: formatDateForGridFilters(filters[key].startDate),
          },
        },
        {
          [key]: {
            lte: formatDateForGridFilters(
              filters[key].endDate,
              undefined,
              true
            ),
          },
        },
      ];

      return arr;
    }
  }
};
export const getStartAndEndDate = (duration = "", subtractCount) => {
  return {
    startDate: moment().startOf(duration),
    endDate: moment().endOf(duration),
  };
};

export const makeCustomParams = (filters, fields = []) => {
  let params = [];
  let { startDate, endDate } = getStartAndEndDate("year");

  let outSideParams = {
    startDate,
    endDate,
  };

  if (filters)
    Object.keys(filters).map((arg) => {
      if (filters[arg] && arg != "locationBy" && filters[arg] != "-1") {
        let field = fields.find((f) => f.name == arg);
        if (field) {
          if (field?.type == "checkbox" || field?.type == "checkbox-list") {
            if (filters[arg] && filters[arg].length)
              params.push({ [arg]: { in: filters[arg] } });
          } else if (["slider", "date_range"].includes(field?.type)) {
            if (field.outsideWhere) {
              console.log(filters);
              if (field?.type == "slider") {
                outSideParams = {
                  startDate: filters[arg]?.[0] || startDate,
                  endDate: filters[arg]?.[1] || endDate,
                };
              } else {
                outSideParams = {
                  startDate: filters[arg]?.startDate || startDate,
                  endDate: filters[arg]?.endDate || endDate,
                };
              }
            } else
              params.push(...makeDataByFieldType(field.type, arg, filters));
          } else {
            if (filters[arg] != -1) {
              if (field?.hasNAOption && filters[arg] === REPORT_NA_VALUE) {
                params.push({ [arg]: { eq: 0 } });
              } else {
                params.push({
                  [arg]: { eq: filters[arg] },
                });
              }
            }
          }
        } else {
          // If the field is not defined in the template fields, we only allow location properties
          if (["countryId", "stateProvinceId", "city"].includes(arg)) {
            if (filters[arg] != -1)
              params.push({
                [arg]: { eq: filters[arg] },
              });
          }
        }
      }
    });

  const fixedUTC = (arg) => {
    const date = new Date(arg);
    return moment.utc({
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate(),
    });
  };
  outSideParams = {
    startDate: outSideParams.startDate
      ? fixedUTC(outSideParams.startDate).startOf("day").toISOString()
      : outSideParams.startDate,
    endDate: outSideParams.endDate
      ? fixedUTC(outSideParams.endDate).endOf("day").toISOString()
      : outSideParams.endDate,
  };
  return { params, outSideParams };
};

export const makeOutsideParams = () => {};
